import { render } from "./ServicesComp.vue?vue&type=template&id=4f7a294a&ts=true"
import script from "./ServicesComp.vue?vue&type=script&lang=ts"
export * from "./ServicesComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__